import { createFitments, Fitments } from './fitments';
import { ZMediaText } from './z-media-text.class';
import { ZVideoSafeURL } from './ZVideoSafeURL';

export class MachineInfos {
    matnr: string;
    maktx: string;
    detectedType: string;
    consigned: string;
    serNr: string;
    equNr: string;
    chassisnr: string;
    highlights: string;
    technicalData: string;
    videos: ZVideoSafeURL[] = [];
    images: string[] = [];
    fitments: Fitments = createFitments();
    brochures: ZMediaText[] = [];
    manuals: ZMediaText[] = [];
    retrofitManuals: ZMediaText[] = [];
    assemblingInstructions: ZMediaText[] = [];
    repairingInstructions: ZMediaText[] = [];
    sparepartsLists: ZMediaText[] = [];
    lubricationPlans: ZMediaText[] = [];
    mechatronicPlans: ZMediaText[] = [];
}
